import React, {
  useEffect,
  useState,
  useRef,
  useContext,
} from 'react';
import { firestore } from '../firebase/firebase';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@material-ui/data-grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import {
  // BrowserRouter as Router,
  // Switch,
  Route,
  // Link,
  useHistory,
  Redirect,
} from 'react-router-dom';
// import { Button } from '@material-ui/core';
// import AddIcon from '@material-ui/icons/Add';
import { UserContext } from '../providers/UserProvider';

function Stores() {
  const { user } = useContext(UserContext);
  const [stores, setStores] = useState([]);
  const isMounted = useRef(false);

  let history = useHistory();

  useEffect(() => {
    isMounted.current = true;
    const init = async () => {
      getStores();
    };
    init();

    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleRowClick = (param) => {
    const id = param.row.id;
    history.push("/butiker/" + id);
  };

  const getStores = async () => {
    try {
      const storesSnapshot = await firestore
        .collection('stores')
        .get();
      const stores = [];
      storesSnapshot.forEach((store, index) => {
        const data = store.data();
        stores.push({
          ...data,
        });
      });
      isMounted.current && setStores(stores);
    } catch (error) {
      console.error(error);
    }
  };

  const classes = useStyles();

  const columns = [
    { field: "name", headerName: "Namn", width: 250 },
  ];

  const rows = stores.reduce((result, store) => {
    typeof store.id === 'string' && result.push({
      id: store.id,
      name: store.name,
    });
    return result;
  }, []);

  return (
    <Route
      render={() =>
        user.accessLevel === 10 ? (
          <div style={{ textAlign: "left" }}>
            <Typography
              component="h1"
              variant="h5"
              color="primary"
              style={{ textAlign: "left", marginBottom: 30 }}
            >
              Butiker
            </Typography>
            {/* <Button
              variant="outlined"
              color="primary"
              style={{
                  marginTop: 9,
                  marginLeft: 0,
                  marginBottom: 20,
              }}
              onClick={() => history.push("/butiker/ny/")}
              startIcon={<AddIcon />}
          >
              Lägg till butik
          </Button> */}
            <Paper className={classes.paper}>
              <div
                style={{ height: 400, width: "100%" }}
                className={classes.root}
              >
                <DataGrid
                  columns={columns}
                  rows={rows}
                  pageSize={10}
                  onRowClick={handleRowClick}
                />
              </div>
            </Paper>
          </div>
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
}

export default Stores;

const useStyles = makeStyles((theme) => ({
  root: {
    "& div.MuiDataGrid-row": {
      cursor: "pointer",
    },
  },
  seeMore: {
    marginTop: theme.spacing(3),
    table: {
      minWidth: 650,
    },
  },
  searchForm: {
    width: "100%",
    marginBottom: 40,
  },
  searchInput: {
    width: "50%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  formControl: {
    marginRight: theme.spacing(1),
    width: 150,
    marginBottom: 30,
  },
  ul: {
    marginBottom: 50,
    "& li": {
      marginBottom: 10,
    },
  },
}));
